// src/services/customerContact.service.ts
import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import { IConfigurationResponse } from "@/apps/merchant3/models/IConfigurationResponse";

export const getConfigurations = async (
  cartTag: string,
  currentStep: string
): Promise<AxiosResponse<IConfigurationResponse>> => {
  const response = await jwtApiClient.get(M3_API(cartTag).CONFIGURATIONS, {
    params: {
      step: currentStep,
    },
  });
  return response.data;
};
